import { render, staticRenderFns } from "./SwitchIf.vue?vue&type=template&id=fa807504"
import script from "./SwitchIf.vue?vue&type=script&lang=js"
export * from "./SwitchIf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports